import React from 'react';
import {
  List,
  TextField,
  Filter,
  SearchInput,
  DateField,
  SelectInput,
} from 'react-admin';
import Chip from '@material-ui/core/Chip';
import { ZippityDatagrid } from '../../components';
import FlagToggle from './components/FlagToggle';
import DeleteButton from './components/DeleteButton';
import ConvertToAppointmentButton from './components/ConvertToAppointmentButton';
import { getCompatibleTextColor } from '../../calendar/colors';
import { getZ3PConfigValue } from '../../helper';

const QuoteDraftListFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
    <SelectInput
      alwaysOn
      source="status"
      emptyText="All"
      choices={[
        { id: 'draft', name: 'Draft' },
        { id: 'sent', name: 'Sent' },
      ]}
    />
  </Filter>
);
const QuoteActionsMenu = (props) => {
  const { record, resource } = props;
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <FlagToggle record={record} resource={resource} />
      <ConvertToAppointmentButton record={record} />
      <DeleteButton record={record} resource={resource} />
    </div>
  );
};

const StatusChipField = ({ record, addLabel = true }) => {
  const { status } = record;

  const grey = '#e0e0e0';
  const blue = '#4ccaf0';
  const yellow = '#ffff60';

  let backgroundColor = grey;

  if (!status) {
    return null;
  }

  if (status === 'draft') {
    backgroundColor = yellow;
  } else if (status === 'sent') {
    backgroundColor = blue;
  }

  const color = getCompatibleTextColor(backgroundColor);
  return (
    <Chip
      key={status}
      label={status}
      style={{ backgroundColor, color, fontWeight: 'bold', fontSize: '11px' }}
    />
  );
};

const QuoteList = (props) => {
  const { is_skipping_vehicle: isSkippingVehicle } = getZ3PConfigValue();
  return (
    <List
      {...props}
      bulkActionButtons={false}
      filters={<QuoteDraftListFilter />}
      filter={{ no_scheduled_work: true }}
      sort={{ field: 'created_at', order: 'DESC' }}
      perPage={50}
    >
      <ZippityDatagrid
        rowClick={(id) => {
          return `/quote-builder?quote_id=${id}`;
        }}
      >
        <DateField source="created_at" label="Date Created" />
        <TextField source="quote_id" />
        <StatusChipField source="status" {...props} />
        <TextField source="quote_request.customer_email" />
        {!isSkippingVehicle ? (
          <TextField source="quote_request.vehicle.display_name" />
        ) : (
          <></>
        )}
        <QuoteActionsMenu {...props} />
      </ZippityDatagrid>
    </List>
  );
};

export default QuoteList;
